import React from 'react';
import { usePeriod } from '../../../../hooks/usePeriod';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { GrossOfFeeIcon } from '../../../../components/GrossOfFeeIcon/GrossOfFeeIcon';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { PerformanceSummary } from '../../../../components/PerformanceSummary/PerformanceSummary';
import { PerformanceVsBenchmarkChart } from '../../../../components/PerformanceVsBenchmarkChart/PerformanceVsBenchmarkChart';
import { PerformanceDetails } from '../../../../components/PerformanceDetails/PerformanceDetails';
import { MobileHelperText } from '../../../../components/MobileHelperText/MobileHelperText';
import { usePerformanceReportingContext } from '../../../../context/usePerformanceReportingContext';
import { MobilePageWrapper } from '../../../../AccountPerformanceReporting.styles';

export const PerformanceMobile = () => {
  const period = usePeriod();

  const { selectedItemName, updatedAt } = usePerformanceReportingContext();

  return (
    <MobilePageWrapper>
      <Box display="flex" flexDirection="column">
        <Box flex={1}>
          <PerformanceVsBenchmarkChart selectedItemName={selectedItemName} updatedAt={updatedAt} />
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        borderColor="neutral.200"
        borderStyle="solid"
        borderWidth="1px 0"
        pt="24"
      >
        <Text variant="cardTitle" mb="24" px="16">
          Performance Summary
          {period.value !== undefined && (
            <>
              {' • '}
              <Text as="span" fontWeight={600} fontSize="h6" color="neutral.500">
                {period.label}
              </Text>
            </>
          )}
          <GrossOfFeeIcon />
        </Text>

        <Box px="16" flex={1} css="overflow-y: auto">
          <PerformanceSummary />
        </Box>
      </Box>

      <PerformanceDetails title="Performance Details" />

      <MobileHelperText />
    </MobilePageWrapper>
  );
};
